/**
 * Returns a promise which sleeps for the given number of milliseconds
 *
 * @internal
 */
export const sleep = (ms: number): Promise<void> => new Promise(r => setTimeout(r, ms));
